import STORE from 'store';

/**
 * Read a driver's per-week reward records for one sub-period (sign-off) period,
 * ordered by window start. The records live in the `driverBonusRewards` Firestore
 * collection — one doc per driver per week, all sharing the parent
 * `bonusPeriodId` — so a single query returns every week of the period. Each
 * record is a full `AnyDriverRewardsOutput` carrying its own weekly
 * `bonusDatasetRecordId`, `startDate` and `endDate`.
 *
 * `GET /rewards` only addresses the parent period (a single record), so this read
 * is the only way to get the weekly breakdown. The collection is deny-by-default
 * in firestore.rules and opened only for the account(s) using the sub-period
 * pattern (currently WEL). Call this only for periods that actually carry
 * `subPeriods` so no other account hits the read. A failed read degrades to [].
 */
const fetchWeeklyRewardRecords = async ({
  accountId,
  driver,
  bonusProgramId,
  bonusPeriodId,
}: {
  accountId: string;
  driver: string;
  bonusProgramId: string;
  bonusPeriodId: string;
}): Promise<BonusTypes.Rewards.AnyDriverRewardsOutput[]> => {
  try {
    const snapshot = await STORE.bonus
      .getDriverRewardsOutputRef({
        accountId,
        driver,
        bonusProgramId,
        intervalId: bonusPeriodId,
      })
      .get();
    return snapshot.docs
      .map((doc) => doc.data())
      .sort((a, b) => a.startDate.localeCompare(b.startDate));
  } catch {
    return [];
  }
};

export default fetchWeeklyRewardRecords;
